import Api from "../axios";

export default async function getPreviousMonthLeave(employeeId) {
  return await Api.get(`/previous_month_leaves?employee_id=${employeeId}`);
}